import { ModalsManager } from '@/components/modals/modalsManager';
import { MCPAddServerModal } from '@/features/mcp/MCPAddServerModal';
import { InstanceUrlModal } from '@/integrations/custom/instance-url-modal';

import { isMetabaseMcpUrl, metabaseMcpUrl } from './url';

import type { GuidedCustomMcpOffer } from '../guided-custom-mcp';

const METABASE_MCP_DISPLAY_NAME = 'Metabase';

async function connectMetabase(): Promise<void> {
  const mcpUrl = await ModalsManager.showResolvable(InstanceUrlModal, {
    title: 'Metabase address',
    description:
      'Enter the address of your Metabase. An admin must enable the MCP server under Admin settings > AI.',
    label: 'Metabase URL',
    placeholder: 'metabase.example.com',
    invalidMessage: 'Enter an https:// Metabase address.',
    toMcpUrl: metabaseMcpUrl,
  });
  if (!mcpUrl) return;

  ModalsManager.show(MCPAddServerModal, {
    initialName: METABASE_MCP_DISPLAY_NAME,
    initialUrl: mcpUrl,
  });
}

export const metabaseOffer: GuidedCustomMcpOffer = {
  id: 'metabase',
  name: METABASE_MCP_DISPLAY_NAME,
  description: 'Query Metabase questions, dashboards, and data.',
  icon: 'metabase',
  categories: ['data_analytics'],
  searchText: 'metabase bi analytics dashboards questions sql mcp',
  isConnected: (servers) =>
    servers.some((server) => isMetabaseMcpUrl(server.url)),
  connect: connectMetabase,
};
